module.exports = __webpack_public_path__ + "static/media/drawer-placeholder.428f42dd.png";